import { JSX } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Home from './Pages/Home/Home';
import Escritorios from './Pages/Escritorios/Escritorios';
import InfoEscritorio from './Pages/Escritorios/InfoEscritorio';
import Documentos from './Pages/Documentos/Documentos';
import Login from './Pages/Login/Login';
import Texto from './Pages/Textos/Texto';

const isAuthentication = (path: any) => {
    const infoLogin = sessionStorage.getItem('infoLogin') || null;
    if (infoLogin) return true;
    
    return false;
};

type PrivateRouteProps = {
    component: () => JSX.Element,
    path?: any,
};

const PrivateRoute = (props: PrivateRouteProps) => {
    const { component: Component, path = null } = props;
    return isAuthentication(path) ? <Component /> : <Navigate replace to={"/login"} />
};

const LoginRoute = () => {
    return isAuthentication(null) ? <Navigate replace to={"/"} /> : <Login />
}

export default function MyRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/login' element={<LoginRoute />} />
                
                <Route path='/escritorios' element={<PrivateRoute component={Escritorios} />} />
                <Route path='/escritorio' element={<PrivateRoute component={InfoEscritorio} />} />
                <Route path='/documentos' element={<PrivateRoute component={Documentos} />} />
                <Route path='/paragrafos' element={<PrivateRoute component={Texto} />} />
                <Route path='/' element={<PrivateRoute component={Home} />} />
            </Routes>
        </BrowserRouter>
    );
}